import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import App from './App'
import * as serviceWorker from './serviceWorker'

import { Provider } from 'react-redux'
import Store from './redux/store'

import { AppState, Auth0Provider } from '@auth0/auth0-react'
import config from './auth_config.json'
import history from './utils/history'

const onRedirectCallback = (appState: AppState): void => {
  history.push(
    appState && appState.returnTo ? appState.returnTo : window.location.pathname
  )
}

ReactDOM.render(
  <Auth0Provider
    domain={config.domain}
    clientId={
      process.env.REACT_APP_MODE === '0' ? config.clientId : config.clientIdLend
    }
    redirectUri={window.location.origin}
    onRedirectCallback={onRedirectCallback}
  >
    <Provider store={Store}>
      <App />
    </Provider>
  </Auth0Provider>,
  document.getElementById('root')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
